import React,{useState,useEffect,useRef} from "react";
import post from "../post";
import { useLocation as location2 } from "wouter";
import Loading from "../components/Loading";


const Success  = () => {
    const [location, navigate] = location2();
    const [loading, setLoading] = useState(true);
    const timer=useRef(null);
    useEffect(() => {
        const finalizeOrder = async () => {
            const currentOrder= JSON.parse(localStorage.getItem('currentOrder'));
            if(currentOrder && currentOrder.order_id){
                const response=await post('preOrderStatus',{order_id:currentOrder.order_id});
                if(response.result==true){
                    //clear cart and current order:
                    localStorage.removeItem('cart');
                    localStorage.removeItem('currentOrder');
                    setLoading(false);
                    //redirect to home after 10 seconds:
                    timer.current=setTimeout(()=>{
                        navigate('/');
                    },5000);
            }else{
                navigate('/');
                return;
            }
            }
        };
        finalizeOrder();
    }, []);
    if(loading){
        return(
            <div id="webcrumbs">

            <div className="min-h-screen bg-gradient-to-b from-primary-50 to-white relative pb-16 flex flex-col items-center justify-center text-neutral-700">
                <Loading  isOpen={true}/>
                </div>
            </div>
        )
    }
    return (
        <div id="webcrumbs">
            
            <div className="min-h-screen bg-gradient-to-b from-primary-50 to-white relative pb-16 flex flex-col items-center justify-center text-neutral-700">
              
                <div className="w-full max-w-3xl px-6 py-10">
                    <div className="flex flex-col items-center mb-8">
                        <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mb-4 shadow-lg transform hover:rotate-12 transition-all">
                            <span className="material-symbols-outlined text-white text-3xl">check_circle</span>
                        </div>
                        <h1 className="text-3xl font-bold text-neutral-900 mb-1">Compra Exitosa</h1>
                        <p className="text-neutral-600 text-center">
                            ¡Gracias por tu compra! Tu pedido ha sido procesado con éxito.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Success;